import Skeleton from "react-loading-skeleton"

const PostSkeleton: React.FC = () => {
    return(
        <div className="mt-n2">
            <Skeleton height={400} />
            <div className="p-3">
            <Skeleton height={100} className="rounded-4" />
            </div>
        </div>
    )
}

export default PostSkeleton